export function extractHouseNumber(address) {
  // Regular expression to match the house number with optional letters
  const houseNumberRegex = /\b\d+[a-zA-Z]?\b/;

  // Match the house number in the address
  const match = address.match(houseNumberRegex);

  // If there is a match, return the house number
  if (match) {
      return match[0];
  } else {
      return null; // No house number found
  }
}